<template>
  <div class="delete__user">
    <v-dialog v-model="value" max-width="800px">
      <v-card>
        <v-toolbar>
          <v-toolbar-title>Удалить пользователя</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text v-if="userInfo">
            <v-container>
              <v-row>
                <v-col>
                  <p>Email: {{ userInfo.email }}</p>
                  <p>Фамилия: {{ userInfo.famil }}</p>
                  <p>Имя: {{ userInfo.name }}</p>
                  <p>Роль: {{ getRoleName(userInfo.role) }}</p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" @click="close">Закрыть</v-btn>
          <v-btn dark color="red" @click="save">Удалить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "delete__user",
  data: () => ({}),
  props: {
    value: {type: Boolean, default: false},
    userInfo: null
  },
  methods: {
    close(){
      this.$emit('close')
    },
    save(){
      this.$emit('save')
    }
  },
};
</script>
<style lang="sass" scoped>
</style>
